import { useRef, useEffect, memo } from "react"
import { MeshStandardMaterial } from "three"
import { useGLTF } from "@react-three/drei"
import { useFrame } from "@react-three/fiber"

import { colours } from "../../../ApartmentFinderConfig/colours"
import { poiType1, poiType2 } from "../../../ApartmentFinderConfig/poi"
import { useStore } from "../../../state/store"

const POIMarker = memo(({ position, nodes, type, id }) => {
  const setPoiActive = useStore(state => state.setPoiActive)
  const setPoiID = useStore(state => state.setPoiID)

  const handleClick = () => {
    // console.log(id)
    // console.log("poiclicked")
    setPoiActive(true)
    setPoiID(type + "_" + id)
  }

  useEffect(() => {
    poiRef.current.rotation.y += Math.random(2) * 20
    // console.log(Math.random(2))
  })

  const poiRef = useRef()

  const labelMat = new MeshStandardMaterial({
    color: type === "two" ? colours.secondaryUI : colours.primaryUI,
    flatShading: true
  })
  const pinMat = new MeshStandardMaterial({
    color: type === "two" ? colours.primaryUI : colours.secondaryUI,
    flatShading: true
  })

  const coloursChange = { labelCol: labelMat.color, pinCol: pinMat.color }
  const handleOver = () => {
    pinMat.color = coloursChange.labelCol
    labelMat.color = coloursChange.pinCol
    document.body.style.cursor = "pointer"
  }
  const handleOut = () => {
    pinMat.color = coloursChange.pinCol
    labelMat.color = coloursChange.labelCol
    document.body.style.cursor = "auto"
  }

  let spin = 1
  useFrame(() => {
    poiRef.current.rotation.y += 0.01
    poiRef.current.position.y = Math.sin((spin += 0.02)) + position[2]
  })

  return (
    <group
      onTap={handleOver}
      onClick={() => handleClick()}
      onPointerOver={handleOver}
      onPointerOut={handleOut}
      scale={type === "one" ? 0.5 : 0.3}
      position={[position[0], position[2], -position[1]]}
      ref={poiRef}
    >
      <mesh material={labelMat} geometry={nodes.label.geometry} />
      <mesh material={pinMat} geometry={nodes.pin.geometry} />
    </group>
  )
})

const PoiMarkers = memo(() => {
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/assets/apartmentfinder/poi/poimarkers.gltf`)
  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)

  const poi1 = Object.values(poiType1)
  const poi1Keys = Object.keys(poiType1)

  const poi2 = Object.values(poiType2)
  const poi2Keys = Object.keys(poiType2)

  // console.log(poiValues)

  if (!apartmentFinderActive) {
    return (
      <>
        {poi1.map((v, i) => (
          <POIMarker type={"one"} id={poi1Keys[i]} position={v} nodes={nodes} />
        ))}
        {poi2.map((v, i) => (
          <POIMarker type={"two"} id={poi2Keys[i]} position={v} nodes={nodes} />
        ))}
      </>
    )
  } else return null
})

export default PoiMarkers
